import { IAppState } from '../common/state';
import { selectIsUserAgent } from '../packages/Filters/shared/selectors';

export const selectIsProfessionalSearchPromoBannerVisible = (state: IAppState) => {
  const isAgent = selectIsUserAgent(state);

  return isAgent;
};
